import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`

:root{
    --gerenalBackgroundColor: #f0f2f5;
    --primaryColor: #518cff;
    --primaryColorHover: #2871ff;
    --cancelColor:#ff5a5a;
    --cancelColorHover:#ff3a3a;
    --successColor:#28a745;
    --backgroundColorHover: #f3f3f3;
    --textBlack: #333333;
    --dark:#343a40;
    --cardBackgroundColor: #fff;
    --BackgroundColorInputs: #fff;
}

*{
    margin:0;
    padding:0;
    outline:0;
    box-sizing:border-box;
}

html , body , #root{
    height:100%;

}

body {
  background: var(--gerenalBackgroundColor);
  font: 14px Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased !important;
  font-family: 'Roboto', sans-serif;
  letter-spacing: .5px!important;
  color: var(--textBlack)!important;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing:antialiased;

}
.acrylic {
  /* Parent background + Gaussian blur */
  backdrop-filter: blur(30px) saturate(180%);
  -webkit-backdrop-filter: blur(30px) saturate(180%);

  /* Exclusion blend */
  background-blend-mode: exclusion;

  /* Color/tint overlay + Opacity */
  background: rgb(152 152 152 / 60%);

  /* Tiled noise texture */
  /* background-image: url(data:image/png;base64,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); */
}

button{
    font: 14px Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased !important;
    font-family: 'Roboto', sans-serif;
    letter-spacing: .5px!important;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing:antialiased;
}

::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f7f7f7;
  border-radius: 5px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 5px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #828282;
}

.backgorundHoverOptions:hover {
    background-color: var(--cardBackgroundColor);
    transition-duration: .3s
}

.customeTheme {
    color: var(--textBlack);
    background-color: var(--cardBackgroundColor)!important;
    opacity:1!important;
    box-shadow: 0px 0px 10px -3px rgba(0,0,0,0.75);
}


.tremerDiv {
  /* Start the shake animation and make the animation last for 0.5 seconds */
  animation: shake 0.5s;

  /* When the animation is finished, start again */
  animation-iteration-count: 1;
}

@keyframes shake {
  0% { transform: translate(1px, 1px);}
  10% { transform: translate(-1px, -2px);}
  20% { transform: translate(-3px, 0px);}
  30% { transform: translate(3px, 2px);}
  40% { transform: translate(1px, -1px);}
  50% { transform: translate(-1px, 2px);}
  60% { transform: translate(-3px, 1px);}
  70% { transform: translate(3px, 1px);}
  80% { transform: translate(-1px, -1px);}
  90% { transform: translate(1px, 2px);}
  100% { transform: translate(1px, -2px);}
}

.vermelho {
    background-color: #ff7171;
    color: var(--cardBackgroundColor);

    :hover{
        background-color: #ff3a3a;
    }
}
.azul {
    background-color: var(--primaryColor);
    color: var(--cardBackgroundColor);

    :hover{
        background-color: var(--primaryColorHover);
    }
}
`;
